/**
 * Where Monaco finds its web workers.
 *
 * monaco-editor-webpack-plugin emits the workers (build/editor.worker.js,
 * json.worker.js …) but tells Monaco about them by injecting
 * `self.MonacoEnvironment` into `vs/editor/editor.(api|main).js` only.
 * setupMonaco imports `edcore.main` instead (to leave the TypeScript service
 * out), so the injection never happened: Monaco found no MonacoEnvironment,
 * logged "Could not create web worker(s). Falling back to loading web worker
 * code in main thread", and ran link detection, word indexing and the JSON
 * language service for every editor ON THE UI THREAD. With a 9.5 MB body that
 * is a freeze after every keystroke (owner, 20.10.2026).
 *
 * The file names are the plugin's `[name].worker.js` defaults, at the root of
 * the build — keep in step with `languages` in craco.config.js.
 */

const WORKER_FILE_BY_LABEL = {
  json: 'json.worker.js',
  css: 'css.worker.js',
  scss: 'css.worker.js',
  less: 'css.worker.js',
  html: 'html.worker.js',
  handlebars: 'html.worker.js',
  razor: 'html.worker.js',
};

/** The URL of the worker Monaco asks for by `label` ('json', 'css', … or 'editorWorkerService'). */
export function monacoWorkerUrl(label, publicUrl = process.env.PUBLIC_URL || '') {
  const file = WORKER_FILE_BY_LABEL[label] || 'editor.worker.js';
  return `${String(publicUrl).replace(/\/$/, '')}/${file}`;
}

/** Install the lookup, unless something (the plugin, a test) already has. */
export function installMonacoWorkers(target = typeof window !== 'undefined' ? window : undefined) {
  if (!target) return;
  const env = target.MonacoEnvironment;
  if (env && (typeof env.getWorkerUrl === 'function' || typeof env.getWorker === 'function')) return;
  target.MonacoEnvironment = { ...(env || {}), getWorkerUrl: (_moduleId, label) => monacoWorkerUrl(label) };
}
